module.exports = __webpack_public_path__ + "static/media/Jomon_icon.57467caf.png";